import axios from "../config/axios";
import { useQuery } from "react-query";

// [6]
const getTableauxByTocId = async (toc_id:string) => {
  const res = await axios.GENERAL.get("/tableaux/by_toc_id/"+toc_id)
  if (res.status === 200) {
    console.log("getTableauxByTocId", res)
    return res.data
  }
}

//  [6-1]
const getTableauxByBookId = async (book_id: string) => {
    const res = await axios.GENERAL.get("/tableaux/by_book_id/"+book_id)
    if (res.status === 200) {
        console.log("getTableauxByBookId", res)
        return res.data
    }
}



// relation
// [14]
// INPUT
// school_id \ if null select All
// person_id\ if null select All
// region_id\ if null select All
const getTableauxBySPR = async(query:any) => {
  const res = await axios.GENERAL.post("/tableaux/relation", query)
  if( res.status===200){
    console.log("getTableauxBySPR", res);
    return res.data
  }
}

// [14-1]
const getTableauxBySchoolId = async(school_id:string) => {
  const res = await axios.GENERAL.get("/tableaux/related_by_school/"+school_id)
  if (res.status===200){
    console.log("getTableauxBySchoolId", res);
    return res.data
  }
}
// [14-2]
const getTableauxByPersonId = async (person_id: string) => {
  const res = await axios.GENERAL.get("/tableaux/related_by_person/"+person_id)
  if (res.status === 200) {
    console.log("getTableauxByPersonId", res)
    return res.data
  }
}
// [14-3]
const getTableauxByRegionId = async (region_id: string) => {
  const res = await axios.GENERAL.get("/tableaux/related_by_region/"+region_id)
  if (res.status === 200) {
    console.log("getTableauxByRegionId", res);
    return res.data
  }
}

export default {
  getTableauxByTocId,
  getTableauxBySPR,
  getTableauxBySchoolId,
  getTableauxByPersonId,
  getTableauxByRegionId
};